import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Location } from '../models/location';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class InternalLocationservice {

  public mtds: Methods = new Methods();

  public url: string;
  public token;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  save(json) {
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.update(json);
    }
  }

  create(json) {
    return this.petition(`${this.url}/internallocation/new`, json);
  }

  update(json) {
    return this.petition(`${this.url}/internallocation/edit/${json.id}`, json);
  }

  getAvailablesForTicket() {
    return this.petition(`${this.url}/internallocation/listavailablesforticket`);
  }

  getAvailablesForTicketNew(json) {
    return this.petition(`${this.url}/internallocation/listavailablesforticketnew`, json);
  }

  showAll() {
    return this.petition(`${this.url}/internallocation/list`);
  }

  showOne(id: any) {
    return this.petition(`${this.url}/internallocation/detail/${id}`);
  }

  onlylinkedlocations(id: any) {
    return this.petition(`${this.url}/internallocation/onlylinkedlocations/${id}`);
  }

  showByWarehouse(id, busqueda = null, page = 1, perpage = 'ALL') {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perpage', perpage.toString());

    if (busqueda === null || busqueda === '') {
      return this.petition(`${this.url}/internallocation/listbywarehouse/${id}`, params);
    } else {
      let json = {
        q: busqueda
      };
      return this.petition(`${this.url}/internallocation/searchbywarehouse/${id}`, params, json);
    }
  }

  listItemsByLocation(id) {
    return this.petition(`${this.url}/weightitem/listbyinternallocation/${id}`);
  }

  delete(id: any) {
    return this.petition(`${this.url}/internallocation/remove/${id}`);
  }

  reserveSpace(id: any) {
    return this.petition(`${this.url}/internallocation/reservedspaces/${id}`);
  }

  editReserveSpace(id: any, json) {
    return this.petition(`${this.url}/internallocation/reservedspaces/edit/${id}`, json);
  }

  deleteBulk(bulk: Array<any>) {
    let json = {
      bulk: bulk
    };
    return this.petition(`${this.url}/internallocation/bulkremove`,null,  json);
  }

 


  petition(url: string, json: any = null, type: any = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = `authorization=${this.token}`;

    if (json != null) {
      json = JSON.stringify(json);
      params = `${params}&json=${json}`;
    }

    if (type != null) {
      params = `${params}&type=${type}`;
    }

    return this._http.post(
      url,
      params,
      { headers: this.headers }
    ).pipe(
      catchError(err => {
        if (err.status === 404) {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }
        throw err;
      })
    );
  }
}
